import React from 'react';
import PropTypes from 'prop-types';
import Ink from 'react-ink';

const TermsAndSubmit = ({ formData, handleInputChange, loading, isExistingAdvisor = false }) => (
  <>
    {/* Terms Checkbox */}
    <div className="flex items-start gap-3 mb-8">
      <input
        id="terms-checkbox"
        type="checkbox"
        checked={formData.agreedToTerms}
        onChange={(e) => handleInputChange('agreedToTerms', e.target.checked)}
        className="w-4 h-4 text-[#49C44F] border-gray-300 rounded focus:ring-[#49C44F]"
        disabled={loading}
        data-testid="ta-terms-checkbox"
      />
      <label
        htmlFor="terms-checkbox"
        className="text-[14px] font-normal leading-[18px] text-black"
        style={{ fontFamily: 'Poppins, sans-serif' }}
      >
        I agree to Ship&Play&apos;s{' '}
        <a href="/terms" target="_blank" rel="noopener noreferrer"
          className="text-blue-600 underline">
          Terms of Use
        </a>
        {' '}and{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer"
          className="text-blue-600 underline">
          Privacy Policy
        </a>
        .
      </label>
    </div>

    {/* Register Button */}
    <button
      type="submit"
      data-testid="ta-register-button"
      className={`
        px-8 py-3 text-white font-semibold text-[16px] leading-[20px]
        bg-[#49C44F] rounded-lg relative
        ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#3fa841]'}
      `}
      style={{ fontFamily: 'Poppins, sans-serif' }}
      disabled={loading}
    >
      {loading
        ? (isExistingAdvisor ? 'Saving...' : 'Registering...')
        : (isExistingAdvisor ? 'Update' : 'Register')}
      {!loading && <Ink />}
    </button>
  </>
);

TermsAndSubmit.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  isExistingAdvisor: PropTypes.bool
};

export default TermsAndSubmit;
